import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImagePreloadDirectiveSharedModule } from '@shared/core/directives/imagePreload/image-preload.directive.shared.module';

import { TagImagesComponent } from './tag-images.shared.component';

@NgModule({
    declarations: [
        TagImagesComponent
    ],
    imports: [
        CommonModule,
        ImagePreloadDirectiveSharedModule,
    ],
    exports: [
        TagImagesComponent
    ],
    providers: [],
})
export class TagImagesModule { }
